import { Fragment, lazy, StrictMode, Suspense } from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { PageLoader } from '@attom';
import { ServiceWorker } from '@utils';
import { store } from '@redux/store';
import { useCheckToken, useDidMount, useUniversal_account, useUniversal_app } from '@hooks';

import '@dist/framework/index.scss';
import '@dist/framework/scss/bootstrap.css';
import '@dist/style/index.scss';
import '@dist/packages/reactToastify/index.scss';
import '@dist/packages/slickCarousel/slick.scss';
import '@dist/packages/slickCarousel/slick-theme.scss';

const Routes = lazy(() => import('@routes'));

const Wrapper = () => {
	const { state: appState, dispatch, actions: appActions } = useUniversal_app();
	const { language } = appState;

	const { actions: accountActions } = useUniversal_account();

	useDidMount(() => {
		// set theme - language - account
		dispatch(appActions.setTheme(localStorage.getItem('_theme') || 'light'));
		dispatch(appActions.setLanguage(localStorage.getItem('_language') || 'fa'));
		dispatch(accountActions.setAccount());
	});

	// Check Token
	const { isCheck: isCheckToken } = useCheckToken();

	// Service Worker
	const sw = new ServiceWorker();
	sw.register('/sw.js', { scope: '/' });

	return (
		<Fragment>
			<Suspense fallback={<PageLoader />}>
				{isCheckToken ? <Routes /> : <PageLoader />}
				<ToastContainer
					position={language === 'fa' ? 'top-right' : 'top-left'}
					draggable={true}
					closeOnClick={true}
					autoClose={4000}
					limit={5}
					rtl={language === 'fa'}
					icon={false}
				/>
			</Suspense>
		</Fragment>
	);
};

render(
	<StrictMode>
		<Provider store={store}>
			<Wrapper />
		</Provider>
	</StrictMode>,
	document.getElementById('root'),
);
